module.exports = __webpack_public_path__ + "img/gmHeadImg.4f17d7d7.png";